import React from 'react';
import ReservationForm from '../components/ReservationForm';

const Reservation = () => {
    return (
        <div className="reservation-page">
            <h1>Reservation</h1>
            <ReservationForm />
        </div>
    );
};

export default Reservation;